import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#1976d2',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          flexWrap: 'wrap',
          gap: 8,
          justifyContent: 'flex-end',
          paddingLeft: 8,
          paddingRight: 8,
        },
        spacer: {
          '@media (max-width:600px)': {
            display: 'none',
          },
        },
        selectLabel: {
          marginBottom: 0,
        },
        displayedRows: {
          marginBottom: 0,
        },
      },
    },
  },
});

export default theme;
